var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecForward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_680_13623)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7115 11.846V9.596H12.0195V9.154H13.154V11.846H12.7115ZM13.8465 11.846V9.154H15.731V11.846H13.8465ZM14.2885 11.404H15.2885V9.596H14.2885V11.404ZM14 14.5C13.4453 14.5 12.9257 14.3957 12.441 14.187C11.9563 13.9783 11.5327 13.6927 11.17 13.33C10.8073 12.9673 10.5217 12.5437 10.313 12.059C10.1043 11.5743 10 11.0547 10 10.5C10 9.94533 10.1043 9.42566 10.313 8.941C10.5217 8.45633 10.8073 8.03266 11.17 7.67C11.5327 7.30733 11.9563 7.02166 12.441 6.813C12.9257 6.60433 13.4453 6.5 14 6.5H14.19L13.358 5.667L13.7115 5.3075L15.154 6.7405L13.731 8.173L13.377 7.8135L14.19 7H14C13.025 7 12.198 7.33966 11.519 8.019C10.84 8.69833 10.5003 9.52533 10.5 10.5C10.4997 11.4747 10.8393 12.3018 11.519 12.9815C12.1987 13.6612 13.0257 14.0007 14 14C14.9743 13.9993 15.8015 13.6598 16.4815 12.9815C17.1615 12.3032 17.501 11.476 17.5 10.5H18C18 11.0547 17.8957 11.5743 17.687 12.059C17.4783 12.5437 17.1927 12.9675 16.83 13.3305C16.4673 13.6935 16.0437 13.979 15.559 14.187C15.0743 14.395 14.5547 14.4993 14 14.5Z",
    fill: "#3D4C5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_680_13623",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_680_13623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_680_13623",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecForward);
export default __webpack_public_path__ + "static/media/rec-forward.05fa10b43917ff50d6492f4143499766.svg";
export { ForwardRef as ReactComponent };